import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import DeliveryMethodsTable from './DeliveryMethodsTable';

import GetCurrenciesQuery from '../../components/Query/Currencies';

interface IDeliveryMethodsProps extends RouteComponentProps<{
  eshop: string;
  deliveryMethodId: string;
}> {

}

export default class DeliveryMethods extends React.Component<IDeliveryMethodsProps> {

  render() {
    return (
      <GetCurrenciesQuery>
        {({ primaryCurrency }: any) => (
          <DeliveryMethodsTable
            domain={this.props.match.params.eshop}
            deliveryMethodId={this.props.match.params.deliveryMethodId}
            currency={primaryCurrency}
          />
        )}
      </GetCurrenciesQuery>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/index.tsx